import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const i18nLocales = {
  en: {
    exportExcel: "Export to Excel",
    configureExportFilters: "Configure export filters",
    reportIsWaiting: "Export is in progress...",
    total: "Total",
    facility: "Facility",
    company: "Company",
    user: "User",
    date: {
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    selectAttributes: "Select attributes",
    buttonCloseLabel: "Choose",
    buttonCancelLabel: "Cancel",
    yes: "Yes",
    no: "No",
    ad: "Login from personal account",
    items: "items",
    actions: {
      disabledUntil: "Unavailable until {date}",
      checklistJsonCopied: "Checklist JSON has been successfully copied to the clipboard",
    },
    checklistImport: {
      button: "Import from JSON",
      title: "Import from JSON",
      textareaLabel: "Checklist JSON",
      import: "Import",
      cancel: "Cancel",
      invalidJson: "Enter valid checklist JSON",
    },
    issuePrint: {
      title: "Print issue",
      hideEmptyFields: "Hide empty fields",
      printImages: "Print attached images",
      cancel: "Cancel",
      submit: "Print",
    },
    carPlateTypes: {
      civil: "Civil",
      police: "Police",
      military: "Military",
      motorcycle: "Motorcycle",
      publicTransport: "Public transport",
      foreign: "Foreign",
    },
    carPlateField: {
      invalidFormat: "Invalid license plate format",
    },
    scheduler: {
      titleNew: "Add scheduler",
      titleEdit: "Edit scheduler",
      titleCopy: "Copy scheduler",
      daily: "By days",
      weekly: "By weeks",
      monthly: "By months",
      early: "By years",
      step1: "Step 1",
      step2: "Step 2",
      step3: "Step 3",
      step4: "Step 4",
      checklist: "Checklist",
      schedulerName: "Name",
      facility: "Facility",
      contract: "Contract",
      object: "Object",
      building: "Building",
      ppr: "MMT level:",
      groupSystem: "Group System",
      system: "System",
      equipment: "Equipment",
      equipmentRequired: "Select equipment",
      events: "Events",
      event: "Event",
      eventName: "Event name",
      periodicity: "Periodicity",
      issuesPeriodicity: "Issue creation frequency",
      startedAt: "Started at",
      finishedAt: "Finished at",
      deadline: "Issue expires in (days)",
      save: "Save",
      correct: "Correct",
      cancel: "Cancel",
      works: "Works",
      worksNotAllowed: "No allowed works",
      worksNormhours: "Normal hours work",
      worksCost: "Works cost",
      materials: "Materials",
      materialsNotAllowed: "No allowed materials",
      materialsCost: "Materials cost",
      totalCost: "Total cost",
      description: "Description",
      addEvent: "Add event",
      submit: "Schedule",
      equipmentPlanning: "EQUIPMENT PLANNING",
      objectPlanning: "PLANNING BY OBJECTS",
      restoreArchivedEventConfirm: "Restore the event from the archive?",
      restoreArchivedEventSuccess: "Event :id has been successfully restored",
      noArchivedEvents: "No events available for restoration",
      deletedEventsConfirm: "Do you confirm deleting the events?",
      deletedEventConfirmSubtext: "You deleted the event :events. Issues will no longer be created for it",
      deletedEventsConfirmSubtext:
        "You deleted the following events: :events. Issues will no longer be created for them",
    },
    history: {
      name: "Name",
      was: "Was",
      became: "Became",
    },
    dashboard: "Dashboard",
    search: "Search",
    showFullResponse: "Show full response",
    deviation: "Deviation",
    openIssue: "Open issue",
    openAct: "Open act",
    actCreated: "Act № {id} successfully created",
    checklistRequiredToComplete: "Checklist is required to complete",
    applyServiceTemplates: "The 'Description' field is already filled in. Allpy service template for field?",
    exportExcelComplete: "Your report is ready! Download it by clicking the icon below:",
  },
  ru: {
    exportExcel: "Выгрузка в Эксель",
    configureExportFilters: "Настроить фильтры выгрузки",
    reportIsWaiting: "Идёт процесс выгрузки",
    total: "Итого",
    facility: "Основная организация",
    company: "Организация",
    user: "Пользователь",
    date: {
      days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
      months: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      daysShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    },
    selectAttributes: "Выберите атрибуты",
    buttonCloseLabel: "Применить",
    buttonCancelLabel: "Отменить",
    yes: "Да",
    no: "Нет",
    ad: "Вход через личный кабинет",
    items: "шт",
    actions: {
      disabledUntil: "Недоступно до {date}",
      checklistJsonCopied: "JSON чеклиста успешно скопирован в буфер обмена",
    },
    checklistImport: {
      button: "Импорт из JSON",
      title: "Импорт из JSON",
      textareaLabel: "JSON чеклиста",
      import: "Импорт",
      cancel: "Отмена",
      invalidJson: "Введите корректный JSON чеклиста",
    },
    issuePrint: {
      title: "Печать заявки",
      hideEmptyFields: "Скрыть пустые поля",
      printImages: "Печать вложенных изображений",
      cancel: "Отмена",
      submit: "Печать",
    },
    carPlateTypes: {
      civil: "Гражданский",
      police: "Полиция",
      military: "Военный",
      motorcycle: "Мотоцикл",
      publicTransport: "Общественный транспорт",
      foreign: "Иностранный",
    },
    carPlateField: {
      invalidFormat: "Некорректный формат гос. номера",
    },
    scheduler: {
      titleNew: "Добавление планирования",
      titleEdit: "Редактирование планирования",
      titleCopy: "Копирование планирования",
      daily: "По дням",
      weekly: "По неделям",
      monthly: "По месяцам",
      early: "По годам",
      step1: "Шаг 1",
      step2: "Шаг 2",
      step3: "Шаг 3",
      step4: "Шаг 4",
      checklist: "Чеклист",
      schedulerName: "Название",
      facility: "Основная организация",
      contract: "Договор",
      object: "Объект",
      building: "Строение",
      ppr: "Уровень ППР:",
      groupSystem: "Группа систем",
      system: "Системы",
      equipment: "Оборудование",
      equipmentRequired: "Выберите оборудование",
      events: "Мероприятия",
      event: "Мероприятие",
      eventName: "Название мероприятия",
      periodicity: "Периодичность",
      issuesPeriodicity: "Частота создания заявок",
      startedAt: "Дата начала",
      finishedAt: "Дата окончания",
      deadline: "Заявка уходит в просрок через (дней)",
      save: "Сохранить",
      correct: "Исправить",
      cancel: "Отмена",
      works: "Работы",
      worksNotAllowed: "Нет доступных работ",
      worksNormhours: "Нормочасов работ",
      worksCost: "Стоимость работ",
      materials: "Материалы",
      materialsNotAllowed: "Нет доступных материалов",
      materialsCost: "Стоимость материалов",
      totalCost: "Итого стоимость",
      description: "Описание",
      addEvent: "Добавить мероприятие",
      submit: "Запланировать",
      equipmentPlanning: "ПЛАНИРОВАНИЕ ПО ОБОРУДОВАНИЮ",
      objectPlanning: "ПЛАНИРОВАНИЕ ПО ОБЪЕКТАМ",
      restoreArchivedEventConfirm: "Восстановить мероприятие из архива?",
      restoreArchivedEventSuccess: "Мероприятие :id успешно восстановлено",
      noArchivedEvents: "Нет доступных мероприятий для восстановления",
      deletedEventsConfirm: "Вы подтверждете удаление мероприятий?",
      deletedEventConfirmSubtext: "Вы удалили мероприятие :events. Заявки по нему перестанут создаваться",
      deletedEventsConfirmSubtext: "Вы удалили мероприятия: :events. Заявки по ним перестанут создаваться",
    },
    history: {
      name: "Название",
      was: "Было",
      became: "Стало",
    },
    dashboard: "Дашборд",
    search: "Поиск",
    showFullResponse: "Показать полный ответ",
    deviation: "Отклонение",
    openIssue: "Открыть заявку",
    openAct: "Открыть акт",
    actCreated: "Акт № {id} успешно создан",
    checklistRequiredToComplete: "Чеклист обязателен к прохождению",
    applyServiceTemplates: "Поле «Описание» уже заполнено. Применить шаблон услуги для него?",
    exportExcelComplete: "Ваш отчет готов! Скачайте его, нажав на иконку ниже:",
  },
};

export default new VueI18n({
  locale: "ru",
  messages: i18nLocales,
});
